import type { SearchUser } from 'lib-shared-types-api';
import { User } from 'lib-shared-types-api';

import { getUserDisplayName } from 'utils/user';

import { DryRunMergeError } from '../mergeContactsModal.types';

/**
 * Replaces user id's in the content with user display names
 *
 * In this case we replace 'with id {user id}' with the display name function so
 * the name is represented in the same way as in the rest of agent interface
 * instead of having the backend return a display name
 *
 * @param content The text to replace user id's in
 * @param contacts The contacts to use for display names
 */
export const replaceUserIdsWithDisplayName = (
  content: string,
  contacts: readonly (User | SearchUser)[],
): string => {
  return contacts.reduce((acc, contact) => {
    return acc.replaceAll(`with id ${contact.id}`, getUserDisplayName(contact));
  }, content);
};

/**
 * Get mapped and formatted merge dry run errors
 *
 * @param causes The error causes from the API response
 * @param contacts The contacts to use data from
 */
export function getMappedMergeDryRunErrors(
  causes: readonly DryRunMergeError[],
  contacts: readonly (User | SearchUser)[],
): readonly DryRunMergeError[] {
  return causes.map((cause) => ({
    title: replaceUserIdsWithDisplayName(cause.title, contacts),
    detail: replaceUserIdsWithDisplayName(cause.detail, contacts),
  }));
}
